export const DEFAULT_LANGUAGE_ISO_CODE = "en";
